import { authenticatedDeletewithPayload, authenticatedPatch } from '../../../../../api/request';

export default async function updateExperience(experienceBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de experiencia.');
    const url = '/doctor-profile/experience';
    return await authenticatedPatch(url, onFail, experienceBody);
}

export async function deleteExperience(idExperience, setErrorMessage) {
  const onFail = () => setErrorMessage('Ocurrió un error eliminando su experiencia.');
  const url = '/doctor-profile/experience';
  const payload = { idExperience };

  return await authenticatedDeletewithPayload(url, onFail, payload);
}